import { createContext, useContext, useEffect } from "react";

export type ScriptAiHubEditorBridgeValue = {
  scriptHasMinimalRunContent: boolean;
  persistDraftBeforeRun?: () => Promise<boolean>;
};

const ScriptAiHubEditorBridgeContext = createContext<React.Dispatch<
  React.SetStateAction<ScriptAiHubEditorBridgeValue | null>
> | null>(null);

export function useScriptAiHubEditorBridge(value: ScriptAiHubEditorBridgeValue | null) {
  const setBridge = useContext(ScriptAiHubEditorBridgeContext);

  useEffect(() => {
    if (!setBridge) return;
    setBridge(value);
    return () => setBridge(null);
  }, [setBridge, value]);
}

export { ScriptAiHubEditorBridgeContext };
